<template>
  <div class="how-it-works">
    <h2>{{ Info.title }}</h2>
    <div class="steps" v-for="step in Info.steps" :key="step.number">
      <div
        class="step"
        data-aos="fade-right"
        data-aos-duration="1000"
        :data-aos-delay="step.number == 1 ? 0 : step.number * 100"
        data-aos-once="true"
      >
        <div class="step-number">{{ step.number }}</div>
        <div class="step-content">
          <h3>{{ step.title }}</h3>
          <p>
            {{ step.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
const { $Aos } = useNuxtApp();
const Info = {
  title: "How It Works",
  steps: [
    {
      number: 1,
      title: "Capture",
      description:
        "Simply scan spaces with your smartphone using our app - no special equipment needed",
    },
    {
      number: 2,
      title: "Process",
      description:
        "Our AI technology automatically stitches and enhances your images into immersive 360° views",
    },
    {
      number: 3,
      title: "Customize",
      description:
        "Add details, descriptions, and interactive elements to enhance the virtual experience",
    },
    {
      number: 4,
      title: "Share",
      description:
        "Deliver professional tours to your clients or embed them directly into websites",
    },
  ],
};

onMounted(() => {
  $Aos.init();
});
</script>

<style lang="scss" scoped>
.how-it-works {
  padding: 6rem 2rem;
  @include respond-below(sm) {
    padding: 4rem 1rem;
  }

  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 39px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.9);
    text-align: center;
    margin-bottom: 2rem;

    @include respond-below(sm) {
      font-size: 28px;
    }
  }

  .steps {
    max-width: 800px;
    margin: 0 auto;

    .step {
      display: flex;
      margin-bottom: 3rem;
      align-items: flex-start;
      .step-number {
        background: rgb(13, 13, 13);
        color: rgba(255, 255, 255, 0.9);
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        font-weight: 700;
        flex-shrink: 0;
        margin-right: 1.5rem;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }

      .step-content {
        h3 {
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 0.5rem;
          color: rgba(255, 255, 255, 0.9);
        }

        p {
          font-size: 18px;
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.4);
        }
      }
    }
  }
}
</style>
